/**
 * Privacy, Terms and Support pages (B-034-PRIV): block content in src/data/legal,
 * the same vocabulary and renderer as the Jñāna Kośa, so the closed-vocabulary
 * check covers them too. The App Store links to /privacy and /support.
 */
import { Section } from '../Learnings/kosa';
import privacy from '../../data/legal/privacy.json';
import terms from '../../data/legal/terms.json';
import support from '../../data/legal/support.json';

export type LegalId = 'privacy' | 'terms' | 'support';

export interface LegalPageContent {
  id: LegalId;
  title: string;
  subtitle: string;
  /** YYYY-MM-DD, shown as "Last updated". */
  updated: string;
  sections: Section[];
}

export const LEGAL_PAGES: Record<LegalId, LegalPageContent> = {
  privacy: privacy as LegalPageContent,
  terms: terms as LegalPageContent,
  support: support as LegalPageContent,
};

export const LEGAL_ORDER: LegalId[] = ['privacy', 'terms', 'support'];

/** The address already on the site, the calendars and the app. */
export const CONTACT_EMAIL = 'universalspiritualpursuit@gmail.com';
